





















import { defineComponent } from '@vue/composition-api';
import ElRadioButton       from 'element-ui/lib/radio-button';

export default defineComponent({
  name: 'cRadioButton',
  components: {
    ElRadioButton,
  },
});
